import React from 'react';

import FallbackSpinner from '../../components/loader/FallbackSpinner';
import createRouteLoadable from './createRouteLoadable';

export const SET_NEW_PASSWORD_PAGE_CHUNK_NAME = 'setNewPasswordPage';

export const SetNewPasswordPage = createRouteLoadable(
  () =>
    import(
      /* webpackChunkName: "setNewPasswordPage" */ '../../pages/SetNewPasswordPage'
    ),
  {
    fallback: <FallbackSpinner />,
  }
);
